import { AppState, ReduxSelector } from 'store/types';
import { ValuesType } from 'utility-types';

const selectAdobeLaunchState: ReduxSelector<
  ValuesType<Pick<AppState, 'adobeLaunch'>>
> = (reduxState: AppState) => reduxState.adobeLaunch;

export const selectPreviousLocation: ReduxSelector<string> = (
  reduxState: AppState,
) => selectAdobeLaunchState(reduxState).previousLocation;
